// import React from 'react'
import React, { useRef, useState } from 'react';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import Arrow from './Arrow';
import Generalsidebar from './Generalsidebar';

const Supportfaq = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const userInfo = JSON.parse(localStorage.getItem('userLoggedIn'))
    ? JSON.parse(localStorage.getItem('userLoggedIn'))
    : { firstName: '' };

  console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const FAQURL =
    'https://thrive-mqy3.onrender.com/v1/docs/#/contact%20us/post_contact_us';
  const form = useRef();

  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm(
  //       "service_r1cti9j",
  //       "template_bx38xro",
  //       form.current,
  //       "iW-c7jNINgutvbSkn"
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //       },
  //       (error) => {
  //         console.log(error.text);
  //       }
  //     );
  // };

  const alertUser = () => {
    localStorage.setItem('key', 'data');
    Swal.fire({
      title: 'Successful',
      text: ` Messaged sent `,
      color: '#186F65',
      confirmButtonColor: '#508D69',
      icon: 'success',
    });

    sendFAQ('techTribe');
  };

  const sendFAQ = async (e) => {
    e.preventDefault();

    try {
      const FAQDetails = {
        name,
        email,
        message,
      };
      console.log('FAQQuestion', FAQDetails);
      const requestData = {
        method: 'POST',
        body: JSON.stringify(FAQDetails),
        headers: { 'Content-Type': 'application/json' },
      };

      const response = await fetch(FAQURL, requestData);
      const data = await response.json();
      console.log('data', data);
    } catch (error) {
      console.log('something went wrong' + error);

      return;
    }
  };

  return (
    <div>
      <Navbar />

      <div onClick={handleArrowClick} className='absolute top-24 left-12 z-20'>
        <Arrow />
      </div>
      <div className={showSidebar ? 'show-sidebar' : 'hidden'}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <form ref={form} className=''>
        <section className='flex items-center justify-center h-52 bg-green-800/10 bg-no-repeat bg-cover relative'>
          <h1 className='uppercase font-bold text-3xl text-green-800/100'>
            ASK US ANYTHING
          </h1>
          <div
            className='h-full w-full opacity-[60%] absolute top-0 left-0'
            style={{
              backgroundSize: 'cover',
              backgroundPosition: 'top',
              backgroundImage:
                'url(https://res.cloudinary.com/dvcxb5tpj/image/upload/v1701082554/fitness_umnuah.jpg)',
            }}></div>
        </section>
        <div className='flex flex-col items-center justify-center mt-4'>
          <h1 className='text-center text-2xl font-bold uppercase text-green-800/100'>
            GET IN TOUCH
          </h1>
          <form className='mt-4 flex flex-col gap-4 md:w-[50%] md:mx-auto'>
            <input
              onChange={(e) => setName(e.target.value)}
              type='text'
              placeholder='Name'
              className='px-4 py-2 border border-[#2A3D19] block w-full rounded-[5px] rounded-md shadow-sm shadow-[#2A3D19]'
            />
            <input
              onChange={(e) => setEmail(e.target.value)}
              type='text'
              placeholder='Email'
              className='px-4 py-2 border border-[#2A3D19] block w-full rounded-[5px] rounded-md shadow-sm shadow-[#2A3D19]'
            />
            <textarea
              onChange={(e) => setMessage(e.target.value)}
              id='message'
              placeholder='Type your question here'
              rows={2}
              className='px-4 py-2 border border-[#2A3D19] block w-full rounded-[5px] h-40 rounded-md shadow-sm shadow-[#2A3D19]'
            />
            <button
              onClick={sendFAQ}
              className='bg-[#295700] shadow-md shadow-[#2A3D19] text-white font-semibold uppercase py-1 rounded-md'
              style={{ marginBottom: '30px', marginTop: '20px' }}>
              Submit
            </button>
          </form>
        </div>
      </form>
      {/* form area end*/}
      <Footer />
    </div>
  );
};

export default Supportfaq;
